var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDtLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 73",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 6h64v64H0z"
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "TitilliumWeb-Bold, Titillium Web",
  fontSize: 48,
  fontWeight: "bold",
  letterSpacing: -1.2,
  fill: "#06C"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 26,
  y: 54
}, "S")), /*#__PURE__*/React.createElement("circle", {
  fill: "#06C",
  cx: 17.5,
  cy: 27.5,
  r: 4.5
}))));
export { SvgDtLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/dt-logo.bec0d239.svg";